import { useState, useEffect, useCallback } from 'react';

interface DeviceMode {
  isMobile: boolean;
  isDesktop: boolean;
  isTouch: boolean;
  width: number;
  height: number;
}

const MOBILE_BREAKPOINT = 768;

export function useDeviceMode(): DeviceMode {
  const [mode, setMode] = useState<DeviceMode>(() => {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1024;
    const h = typeof window !== 'undefined' ? window.innerHeight : 768;
    const isMobile = w <= MOBILE_BREAKPOINT;
    const isTouch = typeof window !== 'undefined' && 'ontouchstart' in window;
    return {
      isMobile,
      isDesktop: !isMobile,
      isTouch,
      width: w,
      height: h,
    };
  });

  const update = useCallback(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isMobile = w <= MOBILE_BREAKPOINT;
    const isTouch = 'ontouchstart' in window;
    setMode({
      isMobile,
      isDesktop: !isMobile,
      isTouch,
      width: w,
      height: h,
    });
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [update]);

  return mode;
}

export function isMobileUserAgent(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(ua);
}

export function useDeviceModeStrict(): DeviceMode {
  const mode = useDeviceMode();
  const isMobile = mode.isMobile || isMobileUserAgent();
  return {
    ...mode,
    isMobile,
    isDesktop: !isMobile,
  };
}